/**
 * View more / View less – toggles visibility of blocks beyond the initial limit.
 * Uses a collapsible wrapper for smooth height transition.
 */
function initViewMoreLess() {
  const containers = document.querySelectorAll('.view-more-less');

  containers.forEach((container) => {
    const el = /** @type {HTMLElement} */ (container);
    const limit = Number.parseInt(el.dataset.limit ?? '2', 10) || 2;
    const viewMoreText = el.dataset.viewMore ?? 'View more';
    const viewLessText = el.dataset.viewLess ?? 'View less';
    const itemsEl = el.querySelector('.view-more-less__items');
    const cta = el.querySelector('[data-view-more-less-trigger]');

    if (!itemsEl || !cta) return;

    const ctaEl = /** @type {HTMLElement} */ (cta);
    const items = Array.from(itemsEl.children).filter(
      (child) => !child.classList.contains('view-more-less__collapsible')
    );

    if (items.length <= limit) {
      ctaEl.style.display = 'none';
      return;
    }

    let collapsible = itemsEl.querySelector('.view-more-less__collapsible');
    let collapsibleInner = collapsible?.querySelector('.view-more-less__collapsible-inner');

    if (!collapsible || !collapsibleInner) {
      collapsible = document.createElement('div');
      collapsible.className = 'view-more-less__collapsible';
      collapsible.setAttribute('aria-hidden', 'true');
      collapsibleInner = document.createElement('div');
      collapsibleInner.className = 'view-more-less__collapsible-inner';
      const extraItems = items.slice(limit);
      const inner = /** @type {HTMLElement} */ (collapsibleInner);
      extraItems.forEach((item) => inner.appendChild(item));
      collapsible.appendChild(collapsibleInner);
      itemsEl.appendChild(collapsible);
    }

    const collapsibleEl = /** @type {HTMLElement} */ (collapsible);

    el.classList.add('view-more-less--collapsed');

    /** @param {boolean} [shouldScroll] */
    function hideExtra(shouldScroll) {
      collapsibleEl.style.height = '0';
      collapsibleEl.classList.remove('view-more-less__collapsible--open');
      collapsibleEl.setAttribute('aria-hidden', 'true');
      ctaEl.textContent = viewMoreText;
      ctaEl.setAttribute('aria-expanded', 'false');
      el.classList.remove('view-more-less--expanded');
      el.classList.add('view-more-less--collapsed');
      if (shouldScroll) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    function showAll() {
      collapsibleEl.classList.add('view-more-less__collapsible--open');
      collapsibleEl.setAttribute('aria-hidden', 'false');
      ctaEl.textContent = viewLessText;
      ctaEl.setAttribute('aria-expanded', 'true');
      el.classList.add('view-more-less--expanded');
      el.classList.remove('view-more-less--collapsed');
      const inner = collapsibleEl.querySelector('.view-more-less__collapsible-inner');
      if (inner) {
        // Force layout so scrollHeight is correct (content may not be measured when parent has height: 0)
        collapsibleEl.style.overflow = 'visible';
        collapsibleEl.style.height = 'auto';
        const h = inner.scrollHeight;
        collapsibleEl.style.height = '0';
        collapsibleEl.style.overflow = '';
        requestAnimationFrame(() => {
          collapsibleEl.style.height = `${h}px`;
        });
      }
    }

    hideExtra();

    ctaEl.addEventListener('click', () => {
      const isExpanded = el.classList.contains('view-more-less--expanded');
      if (isExpanded) {
        hideExtra(true);
      } else {
        showAll();
      }
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initViewMoreLess);
} else {
  initViewMoreLess();
}

document.addEventListener('shopify:section:load', initViewMoreLess);
